<template>
    <div v-if="ver_contatos">
        <!-- Modal -->
        <div class="modal fade" id="verContatosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" style="z-index: 1060">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Contatos</h5>
                        <button type="button" class="close" aria-label="Close" @click="fechar()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ul class="list-group" v-if="contatos">
                            <li class="list-group-item" v-for="(contato, idx) in contatos" :key="idx"
                                :class="!idx ? 'list-group-item-info' : ''">
                                <span class="mr-3">
                                    <span class="badge" :class="'badge-' + contato.contato_status.st_color">
                                        {{ contato.contato_status.search }}
                                    </span>
                                </span>
                                <span class="text-muted small">{{ contato.usuario.st_login }} em {{ $util.getFormatDate(contato.created_at) }} {{ contato.created_at.substr(11,5) }}</span>
                                <div v-if="contato.dt_referencia" class="small">Referência: {{ $util.getFormatDate(contato.dt_referencia) }}</div>
                                <div style="white-space: pre-wrap;" class="small">{{ contato.st_observacoes }}</div>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
``
export default {
    data() {
        return { 
            ver_contatos: false, 
            contatos: null, 
        };
    },

    methods: { 
        abrir(model_type, model_id) {
            this.ver_contatos = true;
            this.contatos = null;

            this.$nextTick(() => {
               
                $('#verContatosModal').modal('show');

                this.$util.load(this, { 
                    service: 'crm',
                    func: 'get_contatos',
                    parms: { 
                        model_type: model_type, 
                        model_id: model_id 
                    },
                    loadTo: res => { 
                        this.contatos = res.lista;
                    }
                });

            });
        },

        fechar() {
            //this.ver_contatos = false;
            //this.contatos = null;
            $('#verContatosModal').modal('hide');
        },
    }
}
</script>
